module.exports = __webpack_public_path__ + "img/magento-migration.327f9ce3.webp";